import * as types from './types';
const initState = {
    status: 'IDLE',
    isConnected: false,
    iss: 0,
    roles: [],
    email: '',
    username: '',
    firstname: '',
    lastname: '',
    token: '',
    phone: ''
};
export default function rolesReducer(state = initState, action) {
    const { type, payload } = action;
    switch (type) {
        case types.FETCH_ROLE_REQUEST:
            return Object.assign(Object.assign({}, state), { status: 'LOADING' });
        case types.FETCH_ROLE_SUCCEEDED:
            return Object.assign(Object.assign(Object.assign({}, state), { status: 'SUCCESS', isConnected: true }), payload);
        case types.FETCH_ROLE_FAILED:
            return Object.assign(Object.assign({}, state), { status: 'FAIL' });
        default:
            return state;
    }
}
